<template>
    <section>
        <b-table
            ref="table"
            :data="executions"
            :striped="true"
            :hoverable="true"
            :narrowed="true"
            :paginated="false"
            :loading="isLoading"
            :show-detail-icon="false"
            @click="toggle"
            detailed
            :mobile-cards="false">

            <template slot-scope="props">
                <b-table-column field="id" label="#" width="40" centered>
                    {{ props.index + 1 }}
                </b-table-column>

                <b-table-column field="start" label="Inicio" width="40" centered>
                    {{ props.row.start_estimated }}
                </b-table-column>

                <b-table-column field="first_name" label="Jinete">
                    {{ `${props.row.rider.lastname} ${props.row.rider.name}` }}
                </b-table-column>

                <b-table-column field="first_name" label="Caballo">
                    {{ props.row.horse.name }}
                </b-table-column>

                <b-table-column field="last_name" label="Lección">
                    {{ props.row.lesson.name}}
                </b-table-column>

                <b-table-column field="last_name" label="Jueces" centered>
                    {{ props.row.judges_executions.length}}
                </b-table-column>

                <b-table-column field="accions" centered>
                  <div class="buttons">
                    <b-button type="is-success" size="is-small" @click.stop="editExecution(props.row.id)">
                      <b-icon icon="pencil" size="is-small"></b-icon>
                    </b-button>
                    <b-button type="is-danger" size="is-small" @click.stop="remove(props.row)" :loading="isLoadingDelete && deletingId === props.row.id" :disabled="props.row.execution_status_id !== 1">
                      <b-icon icon="close" size="is-small"></b-icon>
                    </b-button>
                  </div>
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
              <p>Evaluadores</p>
              <p>
                <span><b-icon icon="circle"  size="is-small" type="is-primary"></b-icon> Jueces</span>&nbsp;
                <span><b-icon icon="circle" size="is-small" type="is-dark"></b-icon> Secretarios</span>
              </p>
              <br>
              <b-field grouped group-multiline>
                <div class="control" v-for="(judgeExecution, index) in props.row.judges_executions" :key="`judge-${index}`">
                    <b-taglist attached>
                        <b-tag type="is-primary">{{ `${judgeExecution.judge.lastname} ${judgeExecution.judge.name}`}}</b-tag>
                        <b-tag type="is-dark" v-if="judgeExecution.secretary">{{ `${judgeExecution.secretary.lastname} ${judgeExecution.secretary.name}`}}</b-tag>
                    </b-taglist>
                </div>
            </b-field>
            </template>

            <section class="section" slot="empty">
                <div class="content has-text-grey has-text-centered">
                <template v-if="isLoading">
                    <p>
                    <b-icon icon="dots-horizontal" size="is-large" />
                    </p>
                    <p>Cargando Registros...</p>
                </template>
                <template v-else>
                    <p>
                    <b-icon icon="horseshoe" size="is-large" />
                    </p>
                    <p>No hay binomios en la nómina&hellip;</p><br>
                    <p>Añade binomios a la nómina desde la pestaña <br> <b>Añadir Binomio</b></p>
                </template>
                </div>
            </section>
        </b-table>
    </section>
</template>

<script>
import ExecutionService from '@/services/ExecutionService.js'

export default {
  props: {
    event: {
      required: true
    },
    eventId: {
      required: true
    },
    reload: {
      default: false,
      type: Boolean
    },
    lastTime: {
      type: String,
      default: null
    }
  },
  created () {
    this.getExecutions()
  },
  data () {
    return {
      isLoading: false,
      executions: [],
      isLoadingDelete: false,
      deletingId: null
    }
  },
  methods: {
    async getExecutions () {
      this.isLoading = true
      let response = await ExecutionService.getExecutions(this.eventId)
      this.executions = response.data.data
      var index = 0
      this.executions.map((execution) => {
        execution['order'] = ++index
      })
      if (this.executions.length > 0) {
        let lastTime = this.executions[this.executions.length - 1].start_estimated
        this.$emit('update:lastTime', lastTime)
      } else {
        let lastTime = this.event ? this.$moment(this.event.start_at, 'HH:mm').subtract(15, 'm') : this.$moment('08:00', 'HH:mm')
        this.$emit('update:lastTime', lastTime.format('HH:mm'))
      }
      this.isLoading = false
    },
    remove (row) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar Binomio',
        message: '¿Está seguro que desea <b>descartar</b> este binomio? <br> Esta acción no se puede deshacer.',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          this.isLoadingDelete = true
          this.deletingId = row.id
          await this.deleteExecution(row.id)
          this.isLoadingDelete = false
          this.deletingId = null
          this.getExecutions()
        }
      })
    },
    editExecution (id) {
      this.$emit('edit', id)
    },
    async deleteExecution (executionId) {
      let response = await ExecutionService.deleteExecution(this.eventId, executionId)
      return response.data.data
    },
    toggle (row) {
      this.$refs.table.toggleDetails(row)
    }
  },
  watch: {
    reload (value) {
      if (value) {
        this.getExecutions()
        this.$emit('update:reload', false)
      }
    }
  }
}
</script>
